import { render, staticRenderFns } from "./common-footer.vue?vue&type=template&id=67fb9abe&scoped=true"
import script from "./common-footer.vue?vue&type=script&lang=js"
export * from "./common-footer.vue?vue&type=script&lang=js"
import style0 from "./common-footer.vue?vue&type=style&index=0&id=67fb9abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb9abe",
  null
  
)

export default component.exports